import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { ThirdPartyLogos } from "~/enums/ThirdPartyLogos"

import type { ContributeLinkProps } from "."
import { ContributeLink } from "."

export const ContributeButton: React.FC<ContributeLinkProps> = ({ url }) => {
  const { t } = useTranslation("contribute")

  return (
    <ContributeLink
      url={url}
      className={clsx(
        "!inline-flex !items-center",
        "rounded-full border-2 border-blue-500",
        "bg-blue-500 !text-white",
        "font-display text-lg font-bold !no-underline",
      )}
    >
      <span className="px-4">{t("openCollective.contributeBtn")}</span>
      <span className="rounded-full bg-white p-2">
        <img
          src={ThirdPartyLogos.OPEN_COLLECTIVE}
          alt=""
          className="!m-0 h-8 w-8"
        />
      </span>
    </ContributeLink>
  )
}
